import { AVATAR_DONE, REMOVE_AVATAR, SET_AVATAR } from './constants';
import { APP_RESET } from '../App/constants';

/** Whether your picture is being changed now. */
function reducer(state = { saving: false }, action) {
  switch (action.type) {
    case SET_AVATAR:
    case REMOVE_AVATAR:
      return { saving: true };
    case AVATAR_DONE:
    case APP_RESET:
      return { saving: false };
    default:
      return state;
  }
}

export default reducer;
